module.exports = __webpack_public_path__ + "img/8_07.79d593ff.png";